
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"40","viewBox":"0 0 41 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.1518 19.4496L16.1607 9.44964C15.9516 9.31098 15.6817 9.29564 15.4582 9.41098C15.2354 9.52631 15.0957 9.75298 15.0957 10.0003V30.0003C15.0957 30.2476 15.2354 30.4743 15.4589 30.5896C15.5584 30.6416 15.6681 30.667 15.7771 30.667C15.9114 30.667 16.0456 30.6276 16.1607 30.551L31.1518 20.551C31.3378 20.427 31.4495 20.221 31.4495 20.0003C31.4495 19.7796 31.3378 19.5736 31.1518 19.4496ZM16.4585 28.7383V11.2623L29.5586 20.0003L16.4585 28.7383Z","fill-rule":"nonzero"}})])
          )
        }
      }
    